import script from "./board_view.vue?vue&type=script&setup=true&lang=js"
export * from "./board_view.vue?vue&type=script&setup=true&lang=js"

import "./board_view.vue?vue&type=style&index=0&id=16931b17&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16931b17"]])

export default __exports__